/**
 * Shared keyboard shortcut helpers for the app.
 * 
 * Provides:
 * - focusSearchInput: Opens sidebar and focuses the search input (Ctrl+F behavior)
 * - requestMapFullscreen: Dispatches a custom event to toggle map fullscreen (F behavior)
 * - MAP_FULLSCREEN_EVENT: The event name used for map fullscreen toggle
 */

export const MAP_FULLSCREEN_EVENT = 'APP_REQUEST_MAP_FULLSCREEN_TOGGLE';

/**
 * Opens the sidebar navigation and focuses the search input.
 * @param {Function} setMainModuleGroupNavigation - function to open/close sidebar
 */
export function focusSearchInput(setMainModuleGroupNavigation) {
    if (document.fullscreenElement) {
        document.exitFullscreen();
    }

    if (setMainModuleGroupNavigation) {
        setMainModuleGroupNavigation(false); // open sidebar
    }

    setTimeout(() => {
        const searchInput = document.querySelector('.raven-search-input input') ||
                            document.querySelector('.raven-search-input') ||
                            document.querySelector('.resource-group-search-filter');
        if (searchInput) {
            searchInput.focus();
            searchInput.select();
        }
    }, 300); // Wait for sidebar animation
}

/**
 * Dispatches a custom event requesting the map to toggle fullscreen.
 * The map component listens for this event and handles the toggle internally.
 */
export function requestMapFullscreen() {
    document.dispatchEvent(new CustomEvent(MAP_FULLSCREEN_EVENT));
}
